export const getQueryParams = () => {
  // eslint-disable-next-line no-restricted-globals
  return new URLSearchParams(window.location.search);
};

export function getDatabasePath(params: { contentId: string; spaceKey: string }): string {
  return `/spaces/${encodeURIComponent(params.spaceKey)}/database/${encodeURIComponent(
    params.contentId
  )}`;
}

export function getEntryPath(params: {
  contentId: string;
  entryId: string;
  spaceKey: string;
}): string {
  return `/spaces/${encodeURIComponent(params.spaceKey)}/database/${
    params.contentId
  }?entryId=${params.entryId}`;
}

export function matchEntryPath(
  url: string
): { spaceKey: string; contentId: string; entryId: string } | undefined {
  const m = url.match(/\/spaces\/([^/?#]+)\/database\/([^/?#]+)\?entryId=([^/?#]+)$/);

  if (m) {
    return {
      spaceKey: decodeURIComponent(m[1]),
      contentId: decodeURIComponent(m[2]),
      entryId: decodeURIComponent(m[3]),
    };
  }
}

/**
 * Match the content ID in the given page or blogpost URL. If no content ID can be found (for example
 * because the given URL is not a page or blogpost URL), undefined is returned.
 */
export function matchViewPageOrBlogpostPath(
  url: string,
  fallbackId?: string
): { contentId: string } | undefined {
  let m = url.match(/\/spaces\/[^/?#]+\/pages\/([0-9]+)($|[/?#])/);

  if (m) {
    return { contentId: m[1] };
  }

  m = url.match(/\/spaces\/[^/?#]+\/overview\?(.*&)?homepageId=([0-9]+)/);

  if (m) {
    return { contentId: m[2] };
  }

  // when no homepageId parameter is defined we use the fallbackId
  m = url.match(/\/spaces\/[^/?#]+\/overview/);

  if (m && fallbackId) {
    return { contentId: fallbackId };
  }

  m = url.match(/\/spaces\/[^/?#]+\/blog\/[0-9]+\/[0-9]+\/[0-9]+\/([0-9]+)($|[/?#])/);

  if (m) {
    return { contentId: m[1] };
  }

  m = url.match(/\/pages\/viewpage\.action\?(.*&)?pageId=([0-9]+)/);

  if (m) {
    return { contentId: m[2] };
  }
}

export function matchUserPath(url: string): { accountId: string } | undefined {
  const m = url.match(/\/people\/([^/?#]+)/);

  if (m) {
    return {
      accountId: m[1],
    };
  }
}

/**
 * Returns a URL link with query parameters contentId, entryId, and savedViewId
 */
export function getDatabaseLinkUrlWithQueryParams({
  baseUrl,
  databasePath,
  contentId,
  entryId,
  viewId,
}: {
  baseUrl: string;
  databasePath: string;
  contentId: string;
  entryId: string;
  viewId: string | undefined;
}): URL {
  const url = new URL(baseUrl + databasePath);

  url.searchParams.set('contentId', contentId);
  url.searchParams.set('entryId', entryId);

  if (viewId) {
    url.searchParams.set('savedViewId', viewId);
  }

  return url;
}
